module.exports = __webpack_public_path__ + "static/media/audio-test.9566562.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio-test.mp3
// module id = /4kb
// module chunks = 1